import { render, staticRenderFns } from "./RentalServices.yaml?vue&type=template&id=24cffc52&component"
import script from "./RentalServices.yaml?vue&type=script&lang=ts&component"
export * from "./RentalServices.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports